export default {
  title: "Gym selection",
};
